export default "__VITE_ASSET__BZz3RYlx__"